export default __webpack_public_path__ + "static/media/wind1.a8071b40.png";